import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/Japan.png'


const _hoisted_1 = { class: "background-container" }
const _hoisted_2 = { class: "login-frame" }
const _hoisted_3 = { class: "language-message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("img", {
        class: "logo",
        src: _imports_0
      }, null, -1)),
      _createVNode(_component_el_button, {
        class: "login-btn",
        onClick: $setup.navToHomePage
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("loginBtn")), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_radio_group, {
          modelValue: $setup.radio,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.radio) = $event)),
          onChange: $setup.handleLanguageChange,
          class: "language-selector"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio, { label: 2 }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("English")
              ])),
              _: 1
            }),
            _createVNode(_component_el_radio, { label: 4 }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("日本語")
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('languageMsg')), 1)
      ])
    ])
  ]))
}